import { render, staticRenderFns } from "./demonstrat.vue?vue&type=template&id=44f658bc"
import script from "./demonstrat.vue?vue&type=script&lang=js"
export * from "./demonstrat.vue?vue&type=script&lang=js"
import style0 from "./demonstrat.vue?vue&type=style&index=0&id=44f658bc&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports